import styles from './style.module.css';
import getByteSize from "../../../utils/getByteSize";
import dateFormat from "../../../utils/dateFormat";
import getUsername from "../../../utils/getUsername";
import getTags from "../../../utils/getTags";
import {useState, useEffect} from "react";
import {useRecoilState} from "recoil";
import {namespaceState} from "../../../recoil/atoms";
import useApi from "../../../services/useApi";

export default function ModelInfo({className, model, editable,onChange,diff=null,mode=null}) {
    const [_model, setModel] = useState(model);
    const [isEditing, setEditing] = useState(false);
    const [nsState, setNsState] = useRecoilState(namespaceState);
    const userId = JSON.parse(localStorage.getItem("account")).id;
    const [description, setDescription] = useState(model.description);
    const [nameAlias, setNameAlias] = useState(model.nameAlias);
    const [tags, setTags] = useState(
        model.userTags&&model.userTags.length > 0 ? model.userTags.join(', ') : '');

    useEffect(() => {
        console.log("model 변경");
        setModel(model);
    }, [model])

    useEffect(() => {
        console.log("_model 변경");
        resetDescs();
        setEditing(false);
    }, [_model])

    const getModel = (modelId) => {
        useApi.get('/ngp/modelreg/mm/model/v1/model?modelId=' + modelId
            + '&namespaceId=' + nsState.id + '&userId=' + userId)
        .then((res) => {
            setModel(res.data);
            setEditing(false);
            onChange();
        })
    }

    const editModel = () => {
        let data = {
            model: {
                modelId: _model.modelId,
                namespaceId: nsState.id,
                userId: userId,
                description: description,
                nameAlias: nameAlias,
                userTags: tags.split(',').map(tag => tag.trim()).filter(
                    tag => tag.trim() !== ''),

            }
        }

        useApi.put('/ngp/modelreg/mm/model/v1/model', data)
        .then((res) => {
            console.log("success");
            getModel(_model.modelId);
        }).catch((err) => {
            console.log(err);
            alert('Failed to update model');
        })
    }

    const onChangeDesc = (e) => {
        setDescription(e.target.value);
    }

    const onChangeAlias = (e) => {
        setNameAlias(e.target.value);
    }

    const onChangeTags = (e) => {
        setTags(e.target.value);
    }

    const resetDescs = () => {
        setDescription(_model.description);
        setNameAlias(_model.nameAlias);
        setTags(_model.userTags?_model.userTags.join(', '): '');
    }

    const edit = () => {
        if (isEditing) {
            resetDescs();
        }
        setEditing(!isEditing);
    }

    return (
        <div className={`${styles['info-wrap']} ${className} ${mode&&styles['lineage-wrap']}`}>
            <div className={`${styles['description']} ${mode&&styles['lineage-detail']}`}>
                <div className={`${styles['detail-box']} ${mode&&styles['detail-box-lineage']}`}>
                    <div className={styles["attribute"]}>
                        <div className={`${styles["attribute-header"]}
                            ${diff?.includes('description')&&styles['attribute-diff']}`}>
                            <p className={`
                            ${styles["attribute-icon"]} 
                            ${styles["icon-sample"]}`}/>
                            Description
                        </div>
                        <div className={styles["attribute-body"]}>
                            {isEditing ?
                                <input disabled={!isEditing}
                                       className={styles["description-input"]}
                                       value={description}
                                       onChange={onChangeDesc}
                                />
                                :
                                <input disabled={true}
                                       className={styles["description-input"]}
                                       value={_model.description}
                                />}

                        </div>
                    </div>
                    <div className={styles["attribute"]}>
                    <div className={`${styles["attribute-header"]}
                            ${diff?.includes('nameAlias')&&styles['attribute-diff']}`}>
                            <p 
                            className={`
                            ${styles["attribute-icon"]} 
                            ${styles["icon-talk"]}`}/>
                            Alias
                        </div>
                        <div className={styles["attribute-body"]}>
                            {isEditing ?
                                <input
                                    className={styles["description-input"]}
                                    value={nameAlias}
                                    onChange={onChangeAlias}
                                />
                                :
                                <input
                                    className={styles["description-input"]}
                                    value={_model.nameAlias}
                                    disabled={true}/>
                            }
                        </div>
                    </div>
                    <div className={styles["attribute"]}>
                        <div className={`${styles["attribute-header"]}
                            ${diff?.includes('userTags')&&styles['attribute-diff']}`}>
                            <p className={`
                            ${styles["attribute-icon"]} 
                            ${styles["icon-sharp"]}`}/>
                            Tag
                        </div>
                        <div className={styles["attribute-body"]}>
                            {isEditing ?
                                <>
                                    <div>
                                        {getTags(_model.autoTags, [],
                                            1000)}</div>
                                    <input
                                        className={styles["description-input"]}
                                        value={tags}
                                        disabled={!isEditing}
                                        onChange={onChangeTags}
                                    />
                                </>
                                :
                                getTags(_model.userTags, _model.autoTags,
                                    1000)
                            }
                        </div>
                    </div>
                </div>
                {editable&&<div className={styles['btn-box']}>
                    {isEditing ? <>
                            <button
                                className={`${styles['btn']} ${styles['cancel-btn']}`}
                                onClick={edit}>
                            </button>
                            <button
                                className={`${styles['btn']} ${styles['save-btn']}`}
                                onClick={editModel}>
                            </button>
                        </> :
                        <button
                            className={`${styles["btn"]} ${styles['edit-btn']}`}
                            onClick={edit}/>
                    }

                </div>}
            </div>
            {mode&&<hr/>}
            <div className={`${styles['information']} ${mode&&styles['lineage-detail']}`}>
                <div className={`${styles['detail-box']} ${mode&&styles['detail-box-lineage']}`}>
                    <div className={styles["attribute"]}>
                        <div className={styles["attribute-header"]}>
                            <p className={`${styles["attribute-icon"]} ${styles["icon-info"]}`}/>
                            Information
                        </div>
                    </div>
                    <div className={styles["information-attribute"]}>
                        <div className={`
                        ${styles["header"]}
                        ${diff?.includes('modelId')&&styles['attribute-diff']}`}>
                            ID
                        </div>
                        <div className={styles["body"]}>
                            {_model.modelId}
                        </div>
                    </div>
                    <div className={styles["attribute-wrap"]}>
                        <div
                            className={`${styles["attribute-box"]} ${styles["box1"]}`}>
                            <div
                                className={styles["information-attribute"]}>
                                <div className={`
                                ${styles["header"]}
                                ${diff?.includes('type')&&styles['attribute-diff']}`}>
                                    Type
                                </div>
                                <div className={styles["body"]}>
                                    {_model.type}
                                </div>
                            </div>
                            <div
                                className={styles["information-attribute"]}>
                                    <div className={`
                                    ${styles["header"]}
                                    ${diff?.includes('tfModel')&&styles['attribute-diff']}`}>
                                    size
                                </div>
                                <div className={styles["body"]}>
                                    {getByteSize(
                                        _model.tfModel ? _model.tfModel.size
                                            : 0)}
                                </div>
                            </div>
                            <div
                                className={styles["information-attribute"]}>
                                    <div className={`
                                    ${styles["header"]}
                                    ${diff?.includes('createdTime')&&styles['attribute-diff']}`}>
                                    Update date
                                </div>
                                <div className={styles["body"]}>
                                    {_model.createdTime&&dateFormat(_model.createdTime).date}
                                </div>
                            </div>

                        </div>
                        <div
                            className={`${styles["attribute-box"]} ${styles["box2"]}`}>
                            <div
                                className={styles["information-attribute"]}>
                                    <div className={`
                                    ${styles["header"]}
                                    ${diff?.includes('numOfClasses')&&styles['attribute-diff']}`}>
                                    Num Of Classes
                                </div>
                                <div className={styles["body"]}>
                                    {_model.numOfClasses}
                                </div>
                            </div>
                            <div
                                className={styles["information-attribute"]}>
                                    <div className={`
                                    ${styles["header"]}
                                    ${diff?.includes('userMail')&&styles['attribute-diff']}`}>
                                    Author
                                </div>
                                <div className={styles["body"]}>
                                    {getUsername(_model.userMail)}
                                </div>
                            </div>

                        </div>
                    </div>

                    {
                        (_model.modelParameters&&
                            _model.modelParameters.defaultModelParameters
                            !== undefined
                            && _model.modelParameters.defaultModelParameters
                            !== null
                            && Object.keys(_model.modelParameters.defaultModelParameters).length
                            > 0) &&
                        <>
                            <div className={styles["information-attribute"]}>
                                    <div className={`
                                    ${styles["header"]}`}
                                    >
                                    Parameters
                                </div>
                                <div className={styles["parameter-wrap"]}>
                                    {Object.entries(
                                        _model.modelParameters.setModelParameters
                                        && Object.keys(_model.modelParameters.setModelParameters).length
                                        > 0
                                            ? _model.modelParameters.setModelParameters
                                            : _model.modelParameters.defaultModelParameters).map(
                                        ([key, value]) => (
                                            <div
                                                className={styles["parameter"]}>
                                                <p className={styles["parameter-key"]}>
                                                    {key}
                                                </p>
                                                <p className={styles["parameter-value"]}>
                                                    {value.value}
                                                </p>
                                            </div>
                                        ))}
                                </div>
                            </div>
                        </>

                    }
                    <div className={styles["information-attribute"]}>
                        <div className={`
                            ${styles["header"]}
                            ${diff?.includes('module')&&styles['attribute-diff']}`}>
                            Signatures
                        </div>
                        <div className={styles["parameter-wrap"]}>
                            {_model.module&&_model.module.signature&&_model.module.signature.map((signature) => (
                                <div className={styles["parameter"]}>
                                    <p className={styles["parameter-key"]}>
                                        {signature}
                                    </p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}